import React from 'react'
import {
  PROMO_VARIABLE_NAMES,
  StyledFeatureVariable,
} from '@mc/feature-variables'
import { Trans } from '@mc/i18n'
import {
  PROMO_I18N_NAMESPACE,
  PROMO_FEATURE_FLAG,
} from '../../../lib/constants'
import styles from './ExplainerModalContent.module.scss'

export const PromoText = () => (
  <div className='mc-mt-8 row justify-content-center'>
    <h2
      className={`mc-text--brand mc-text--uppercase mc-text-d1 flex-1 col-12 ${styles.subtitle}`}
    >
      <StyledFeatureVariable
        flagName={PROMO_FEATURE_FLAG}
        variableName={PROMO_VARIABLE_NAMES.modalOfferSlogan}
        defaultCopy={
          <>
            <Trans i18nKey='common.title' ns={PROMO_I18N_NAMESPACE}>
              <span className='mc-text-color--tertiary' />
              <span className='mc-text-color--primary' />
            </Trans>
          </>
        }
      />
    </h2>
  </div>
)
